import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import AssignmentForm from "./FormSection";
import {
    locationCity,
    locationZone,
    locationArea,
} from "services/redux/sales/corporate/locations/action";
import {
    getSiteTypes,
    getSiteInformation
} from "services/redux/fileComplain/action"

import {getReportee, search, newAssignee, uploadcsvfile} from "../../../services/redux/BulkAssignment/action";

const mapStateToProps = (state) => ({
    cities: state.locationReducer.cities,
    zones: state.locationReducer.zones,
    areas: state.locationReducer.areas,
    siteTypes: state.fileComplainReducer.siteTypes,
    siteInfo: state.fileComplainReducer.siteInfo,
    reportee: state.bulkAssignmentReducer.reportee,
    searchInfo: state.bulkAssignmentReducer.searchInfo,
    newAssigneeRes: state.bulkAssignmentReducer.newAssigneeRes,
    uploadcsvfile_1: state.bulkAssignmentReducer.uploadcsvfile_1,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getSiteInformation,
        locationCity,
        locationZone,
        locationArea,
        getSiteTypes,
        getReportee,
        search,
        newAssignee,
        uploadcsvfile,
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentForm);
